import React from "react";
import { ScrollView, ScrollViewProps } from "react-native";
import Animated from "react-native-reanimated";
import BottomBarPadding from "./BottomBarPadding";

interface LScrollViewProps extends ScrollViewProps {
  disableAutomaticPadding?: boolean;
  children?: React.ReactNode;
  animated?: boolean;
}

const LScrollView = ({
  disableAutomaticPadding,
  children,
  animated,
  ...rest
}: LScrollViewProps) => {
  const Content = (
    <>
      {children}
      {!disableAutomaticPadding && <BottomBarPadding />}
    </>
  );
  if (animated) {
    return (
      <Animated.ScrollView
        showsVerticalScrollIndicator={false}
        showsHorizontalScrollIndicator={false}
        keyboardDismissMode="on-drag"
        keyboardShouldPersistTaps="handled"
        {...rest}
      >
        {Content}
      </Animated.ScrollView>
    );
  }
  return (
    <ScrollView
      showsVerticalScrollIndicator={false}
      showsHorizontalScrollIndicator={false}
      keyboardDismissMode="on-drag"
      keyboardShouldPersistTaps="handled"
      {...rest}
    >
      {Content}
    </ScrollView>
  );
};

export default LScrollView;
